import { webApi } from "../../../../../core/http/httpThunks";

export const deleteCommissionDetailApi = (userId: string, commdetid: string) =>
	webApi<string>({
		method: "DELETE",
		url: "listing/delcommdet",
		params: {
			userId,
			commdetid
		},
	});

export default deleteCommissionDetailApi;
